import { render } from "./SwapPayoutSetup.vue?vue&type=template&id=b0605e82&scoped=true"
import script from "./SwapPayoutSetup.vue?vue&type=script&lang=js"
export * from "./SwapPayoutSetup.vue?vue&type=script&lang=js"

import "./SwapPayoutSetup.vue?vue&type=style&index=0&id=b0605e82&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0605e82"]])

export default __exports__